import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { MenuItem, Select } from '@mui/material';

import { getTodayFilter } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { updateTableState } from 'redux/slices/common/appSlice';

export const DateFilter = ({
    setFilter,
    filter,
    disabled,
    showCustomOpts,
    intialFilter = 'today',
}: {
    setFilter?: any;
    filter?: any;
    disabled?: boolean;
    showCustomOpts?: boolean;
    intialFilter?: string;
}) => {
    const { pageNumber, ...tableState } = useSelector((state: RootState) => state.app.table);
    const dispatch = useDispatch();
    const [date, setDate] = useState<string>(intialFilter);

    useEffect(() => {
        setDate(intialFilter);
    }, [intialFilter]);

    const handleChange = useCallback(
        (value: any) => {
            if (!setFilter) return;
            const resetTablePagination = { offset: 0, pageNumber: 0 };
            dispatch(updateTableState({ ...tableState, ...resetTablePagination }));
            switch (value) {
                case 'today': {
                    setFilter({
                        ...filter,
                        ...resetTablePagination,
                        ...getTodayFilter(),
                    });
                    break;
                }
                case 'yesterday': {
                    const startDate = dayjs().add(-1, 'day').startOf('day');
                    const endDate = dayjs().subtract(1, 'day').endOf('day');
                    setFilter({
                        ...filter,
                        ...resetTablePagination,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'yesterday',
                    });
                    break;
                }
                case 'thisMonth': {
                    const startDate = dayjs().startOf('month');
                    const endDate = dayjs();
                    setFilter({
                        ...filter,
                        ...resetTablePagination,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'thisMonth',
                    });
                    break;
                }
                case 'lastMonth': {
                    const startDate = dayjs().subtract(1, 'month').startOf('month');
                    const endDate = dayjs().subtract(1, 'month').endOf('month');
                    setFilter({
                        ...filter,
                        ...resetTablePagination,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'lastMonth',
                    });
                    break;
                }
                case 'all': {
                    setFilter({ ...tableState, ...resetTablePagination, value: 'all' });

                    break;
                }
                case 'custom': {
                    setFilter({
                        ...filter,
                        ...resetTablePagination,
                        dayFrom: null,
                        dayTo: null,
                        value: 'custom',
                    });
                    break;
                }
                default:
                    break;
            }
            setDate(value);
        },
        [setFilter, filter, tableState]
    );
    return (
        <Select
            disabled={disabled}
            value={date}
            onChange={(e) => handleChange(e.target.value)}
            sx={{
                fontWeight: 600,
                fontSize: 20,
                width: 'auto',
                '& fieldset': {
                    border: 'none',
                },
                minWidth: 160,
            }}
        >
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="yesterday">Yesterday</MenuItem>
            <MenuItem value="thisMonth">This month</MenuItem>
            <MenuItem value="lastMonth">Last month</MenuItem>
            <MenuItem value="all">All</MenuItem>
            {showCustomOpts && <MenuItem value="custom">Custom</MenuItem>}
        </Select>
    );
};
